import React from 'react';
import { COMPANY } from '../data/siteData';

const RequisitesPage = () => (
    <div className="page">
        <div className="container page-container">
            <h1 className="page-title">Реквизиты</h1>

            <div className="page-content">
                <dl className="requisites-list">
                    <div className="requisites-item">
                        <dt>ИНН</dt>
                        <dd>{COMPANY.inn}</dd>
                    </div>
                    <div className="requisites-item">
                        <dt>ОГРНИП</dt>
                        <dd>{COMPANY.ogrn}</dd>
                    </div>
                    <div className="requisites-item">
                        <dt>Юридический адрес</dt>
                        <dd>{COMPANY.address}</dd>
                    </div>
                    <div className="requisites-item">
                        <dt>E-mail</dt>
                        <dd>
                            <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
                        </dd>
                    </div>
                </dl>

                <p className="page-note">
                    Информационные услуги по подбору персонала оказываются на основании законодательства
                    Российской Федерации.
                </p>
            </div>
        </div>
    </div>
);

export default RequisitesPage;
